import { FC } from 'react';
import AlertSVG from '../../components/svgs/Alert.svg';
import { ON_FARM_BILLING_CONSTANTS } from '../../constants/common';
import { useOnFarmAgreementGate } from './OnFarmAgreementGateContext';

type OnFarmBillingAgreementBannerProps = {
  canAccept: boolean;
};

const OnFarmBillingAgreementBanner: FC<OnFarmBillingAgreementBannerProps> = ({ canAccept }) => {
  const { requiresAgreementGate, openAgreementModal } = useOnFarmAgreementGate();

  if (!requiresAgreementGate) {
    return null;
  }

  return (
    <section className="on-farm-status-banner on-farm-status-banner--agreement">
      <div className="on-farm-status-banner__icon">
        <AlertSVG />
      </div>
      <p className="on-farm-status-banner__copy">
        {canAccept ? ON_FARM_BILLING_CONSTANTS.AGREEMENT_GATE_BANNER : ON_FARM_BILLING_CONSTANTS.AGREEMENT_GATE_CONTACT_MANAGER}
      </p>
      {canAccept && (
        <button className="button green medium on-farm-status-banner__action" type="button" onClick={openAgreementModal}>
          {ON_FARM_BILLING_CONSTANTS.AGREEMENT_REVIEW_ACCEPT}
        </button>
      )}
    </section>
  );
};

export default OnFarmBillingAgreementBanner;
